import React, { useState } from 'react'
import styles from './banner.module.scss'
import Skeleton from 'react-loading-skeleton'

function Banner({ handleClick }) {
  const imgBanner = 'banner.png'

  const [isLoadedImg, setIsLoadedImg] = useState(false)

  function isLoaded() {
    setIsLoadedImg(true)
  }

  function renderHeader() {
    return (
      <picture onClick={handleClick} className={styles.bannerLink}>
        <button
        type="button"
        className={`ty-button ty-button--large ${styles.start_button}`}
        >
          Comece Agora
        </button>
        <source
          media="(min-width: 465px)"
          srcSet={require(`../../img/${process.env.REACT_APP_BRAND}/banner/desktop/${imgBanner}`)}
          alt="Ação de Dia dos Namorados"
          onLoad={isLoaded}
        />
        <img
          src={require(`../../img/${process.env.REACT_APP_BRAND}/banner/mobile/${imgBanner}`)}
          className={styles.banner}
          onLoad={isLoaded}
          alt="Ação de Dia dos Namorados"
        />
      </picture>
    );
  }

  return (
    <>
      {renderHeader()}
      {!isLoadedImg && <Skeleton height={540} width="100%" />}
    </>
  )
}

export { Banner }
